.items {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-size: 1.6rem;
  line-height: 1.6;
  vertical-align: middle;
  border-radius: 2.4rem;
}

.item {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--color-white);
  transition: background-color 0.3s ease-in-out;
}

.item + .item {
  margin-top: 0.1rem;
}

.item:first-of-type > h3 > button {
  border-top-left-radius: 2.4rem;
  border-top-right-radius: 2.4rem;
}

.item:last-of-type > h3 > button[aria-expanded='false'] {
  border-bottom-right-radius: 2.4rem;
  border-bottom-left-radius: 2.4rem;
}

.itemExpand {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem;
  cursor: pointer;
}

/* only adds a border if the keyboard is being used to navigate */
.itemExpand:not(.pristine):focus {
  box-sizing: border-box;
  border: 0.1rem solid rgba(var(--color-fountain-blue-rgb), 0.4);
}

/* 
*  only shows dotted line if pristine or not focused 
*  this is just so that the line shows if you use the keyboard to focus a non expanded item
*/
.item > .header:not(:focus-within) + .expanded > .accordionItemContent,
.pristine > .accordionItemContent {
  border-top: 0.1rem dashed rgba(var(--color-regent-gray-rgb), 0.55);
}

.itemContentContainer {
  position: relative;
  max-height: 0;
  padding: 0 2.4rem 0 6.6rem;
  transition: max-height 300ms ease-in-out;
}

.item:last-child .itemContentContainer.expanded {
  padding-bottom: 1.2rem;
}

.itemContentContainer.expanded {
  max-height: 18rem;
}

.itemName {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.benefitIcon {
  margin-right: 2.6rem;
  color: var(--color-peach-orange);
}

.savingsValue {
  color: var(--color-state--success);
  font-weight: bold;
}

.benefitSavings {
  display: flex;
  flex-direction: row;
  align-items: center;
  vertical-align: middle;
}

.accordionItemContent {
  flex-direction: column;
  align-items: flex-start;
  padding: 1.2rem 0;
  color: var(--color-semantic-text-neutral30);
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.6;
}

.disabled {
  background: rgba(var(--color-white-rgb), 0.6);
}

.chevron {
  margin-left: 0.6rem;
  transition: 300ms ease-in-out;
}

.chevron.flipped {
  transform: rotate(-180deg);
}

.detailRow {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.2rem;
}

.rowLabel {
  display: flex;
  flex: 1;
}

.detailRow:first-of-type,
.detailRow:last-of-type {
  margin-bottom: 1.6rem;
}

.header {
  display: flex;
  flex: 1;
  color: var(--color-semantic-text-neutral30);
  font-weight: 400;
  font-size: 1.6rem;
  font-style: normal;
  line-height: 1.6;
}

.link:not(.pristine):focus {
  border-radius: 0.4rem;
  outline: 0.1rem solid rgba(var(--color-fountain-blue-rgb), 0.4);
}
